<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { CustomBlockComponentProps } from '@portabletext/svelte';

  interface Props {
    portableText: CustomBlockComponentProps<{
      listItem: 'number' | 'bullet';
    }>;
    children?: Snippet;
  }

  let { portableText, children }: Props = $props();
</script>

<svelte:element this={portableText.value.listItem === 'number' ? 'ol' : 'ul'}>
  {@render children?.()}
</svelte:element>

<style>
  ul,
  ol {
    margin: 0;
    padding: 0;
    margin-left: 20px;
    list-style-position: outside;
  }
</style>
